var SearchModule = (function () {
    function SearchModule() {
    }
    return SearchModule;
}());
export { SearchModule };



// WEBPACK FOOTER //
// /opt/app/src/app/features/search/search.module.ts.pre-build-optimizer.js